import { render, staticRenderFns } from "./MenuEditSoups.vue?vue&type=template&id=f3a1ffca&scoped=true"
import script from "./MenuEditSoups.vue?vue&type=script&lang=js"
export * from "./MenuEditSoups.vue?vue&type=script&lang=js"
import style0 from "./MenuEditSoups.vue?vue&type=style&index=0&id=f3a1ffca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a1ffca",
  null
  
)

export default component.exports